import { render } from "./VegetarianDetails.vue?vue&type=template&id=96face1a"
import script from "./VegetarianDetails.vue?vue&type=script&lang=js"
export * from "./VegetarianDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__